import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import Loader from "./Loader";
var DebounceLoader = /*#__PURE__*/function (_PureComponent) {
  _inherits(DebounceLoader, _PureComponent);
  var _super = _createSuper(DebounceLoader);
  function DebounceLoader(props) {
    var _this;
    _classCallCheck(this, DebounceLoader);
    _this = _super.call(this, props);
    _this.state = {
      loaded: true
    };
    var bounceTimeout = _this.props.bounceTimeout;
    _this.show = _this.show.bind(_assertThisInitialized(_this));
    _this.hide = _this.hide.bind(_assertThisInitialized(_this));
    _this.showWithDebounce = debounce(_this.show, bounceTimeout);
    return _this;
  }
  _createClass(DebounceLoader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var loaded = this.props.loaded;
      var stateLoaded = this.state.loaded;
      if (stateLoaded !== loaded) {
        this.initiate(loaded);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var loaded = this.props.loaded;
      if (prevProps.loaded !== loaded) {
        this.initiate(loaded);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelShow();
    }
  }, {
    key: "initiate",
    value: function initiate(loaded) {
      if (loaded) {
        this.hide();
      } else {
        this.showWithDebounce();
      }
    }
  }, {
    key: "show",
    value: function show() {
      var loaded = this.props.loaded;
      this.setState({
        loaded: loaded
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      this.cancelShow();
      this.setState({
        loaded: true
      });
    }
  }, {
    key: "cancelShow",
    value: function cancelShow() {
      this.showWithDebounce.cancel();
    }
  }, {
    key: "render",
    value: function render() {
      var loaded = this.state.loaded;
      var children = this.props.children;
      return /*#__PURE__*/React.createElement(Loader, {
        loaded: loaded
      }, children);
    }
  }]);
  return DebounceLoader;
}(PureComponent);
DebounceLoader.propTypes = {
  loaded: PropTypes.bool.isRequired,
  bounceTimeout: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
DebounceLoader.defaultProps = {
  bounceTimeout: 1000
};
export default DebounceLoader;